import React, { useEffect, useState } from "react";
import FilterGroup from "./filterGroup";
import { SFStack } from "../../grid";
import getStyled from "../../../hooks/getStyled";
import { getGridFilterValues } from "../../../services/dataGridService";
import { getFilterModelObj } from "./getFilterModelObject";

const { styled } = getStyled();

const FilterGroupContainer = styled(SFStack)(({ theme }) => ({
  maxHeight: `calc(100vh - ${theme.spacing(13.5)})`,
  overflowY: "auto",
}));

const FilterGroups = ({
  filters = [],
  currentSelection,
  updateCurrentSelection,
  clearCurrentSelection,
  currentFilterModel = {},
  colNameTypes = {},
  singleGetAllValuesUrl,
  keepFiltersOpen,
  expandedFilterGroups,
  filterGroupToggleHandler,
  externalColNameTypes,
  externalFilterSelection,
}) => {
  const [datasource, setDatasource] = useState(
    singleGetAllValuesUrl ? { loading: true } : null
  );

  const [disableAll, setDisableAll] = useState(false);

  useEffect(() => {
    let ignore = false;
    if (singleGetAllValuesUrl) {
      // Create a copy of the currentSelection object
      const updatedCurrentSelection = { ...currentSelection };
      // Create the advanced query object for the current filter
      const filterModel = getFilterModelObj(
        { ...updatedCurrentSelection, ...externalFilterSelection },
        { ...colNameTypes, ...externalColNameTypes }
      );

      // Create the filter model object for the payload
      filterModel.searchText = currentFilterModel.searchText;
      if (
        (currentFilterModel.searchText &&
          typeof currentFilterModel.searchText === "object") ||
        keepFiltersOpen
      ) {
        setDisableAll(true);
        getGridFilterValues(singleGetAllValuesUrl, filterModel).then((res) => {
          if (!ignore) {
            setDatasource(res.data);
          }
          setDisableAll(false);
        });
      }
    }
    return () => {
      ignore = true;
    };
  }, [
    JSON.stringify(currentFilterModel.advancedQuery),
    JSON.stringify(currentFilterModel.searchText),
  ]);

  return (
    <FilterGroupContainer>
      {!datasource.loading &&
        filters.map((filter, index) => {
          return (
            <FilterGroup
              key={index}
              filter={filter}
              datasource={datasource?.find(
                (item) => item.columnName === filter.colName.toLowerCase()
              )}
              currentSelection={currentSelection}
              updateCurrentSelection={updateCurrentSelection}
              clearCurrentSelection={clearCurrentSelection}
              currentFilterModel={currentFilterModel}
              singleGetAllValuesUrl
              colNameTypes={colNameTypes}
              disableAll={disableAll}
              expandedFilterGroups={expandedFilterGroups}
              onFilterGroupToggle={filterGroupToggleHandler}
              externalColNameTypes={externalColNameTypes}
              externalFilterSelection={externalFilterSelection}
            />
          );
        })}
    </FilterGroupContainer>
  );
};

export default FilterGroups;
